import { Body, Shape, SubTitle, styled } from '@teko/ds-desktop';
import { DownOutlined, GreenGiffColored, UpOutlined } from '@teko/ds-icon';
import { RelatedPromotionV2 } from 'components/RelatedPromotionV2';
import { useProductDetailState } from 'contexts';
import { useDetailPromotion } from 'hooks';
import { t } from 'i18n';
import { useState } from 'react';

export const RelatedPromotions = () => {
  const [showAllPromotions, setShowAllPromotions] = useState(false);
  const { product, price } = useProductDetailState();
  const { validPromotions } = useDetailPromotion(product, price?.finalPrice);
  const displayedPromotions = showAllPromotions
    ? validPromotions
    : [...validPromotions.slice(0, 3)];

  return !!validPromotions?.length ? (
    <Shape padding={['s8', 's0']} marginTop="s8" backgroundColor="white">
      <StyledContent>
        <StyledHeaderContent>
          <GreenGiffColored size={20} />
          <SubTitle level={2} marginLeft="s8">
            {t('Khuyến mãi liên quan')}
          </SubTitle>
        </StyledHeaderContent>
        <Shape padding="s8">
          <StyledUl>
            {displayedPromotions.map((promotion, index: number) => (
              <li key={index} style={{ fontSize: '14px', lineHeight: '20px' }}>
                <RelatedPromotionV2 validPromotion={promotion} />
              </li>
            ))}
          </StyledUl>
          {validPromotions.length > 3 && !showAllPromotions && (
            <ExpandCollapseButton
              onClick={(e) => {
                e.stopPropagation();
                setShowAllPromotions(true);
              }}
            >
              <Body level={1} color="primary" style={{ display: 'block' }}>
                {t('Xem thêm')} <DownOutlined size={16} color="primary" />
              </Body>
            </ExpandCollapseButton>
          )}
          {showAllPromotions && validPromotions.length > 3 && (
            <ExpandCollapseButton
              onClick={(e) => {
                e.stopPropagation();
                setShowAllPromotions(false);
              }}
            >
              <Body level={1} color="primary" style={{ display: 'block' }}>
                {t('Thu gọn')} <UpOutlined size={16} color="primary" />
              </Body>
            </ExpandCollapseButton>
          )}
        </Shape>
      </StyledContent>
    </Shape>
  ) : null;
};

const StyledContent = styled.div`
  border: 1px groove;
  border-radius: 16px;
`;

const StyledHeaderContent = styled.div`
  padding: 8px;
  background-color: #f5f5f5;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  display: flex;
  align-items: center;
`;

const ExpandCollapseButton = styled.div`
  width: fit-content;
  margin: 0.5rem auto;
`;

const StyledUl = styled.ul`
  margin: 0;
  padding-left: 0; // remove default padding of ul
  margin-left: 2rem;
`;
